import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper from 'components/pageWrapper';
import Content from './content';
import classes from './styles.module.scss';

const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer</title>
      </Helmet>
      <PageWrapper heading="Disclaimer">
        <div className={classes.wrapper}>
          <Content />
        </div>
      </PageWrapper>
    </>
  );
};

export default Disclaimer;
